<template>
  <vue-final-modal
      v-slot="{ params, close }"
      v-bind="$attrs"
      classes="flex justify-center items-center"
      content-class="relative flex flex-col h-4/5 max-h-full mx-40 my-20 p-10 border dark:border-gray-800 rounded bg-white dark:bg-gray-900">
    <div class="flex-grow overflow-y-auto">
      <slot :params="params"></slot>
    </div>
    <button class="absolute top-0 right-0 mt-2 mr-2" @click="$emit('close', close)">
      <XMarkIcon class="h-6 w-6" aria-hidden="true" />
    </button>
  </vue-final-modal>
</template>

<script>
import {VueFinalModal} from "vue-final-modal";
import {XMarkIcon} from "@heroicons/vue/20/solid";

export default {
  name: 'TwModal',
  components: {
    VueFinalModal,
    XMarkIcon,
  },
  inheritAttrs: false,
  emits: ['close', 'cancel'],
}
</script>